import httpClient from '@/api/httpClient'
import EstiTmpl from '@/components/estimation/EstiTmpl'
import _ from 'lodash'
import Constant from '@/constant/index'

const state = {
  showTrack: false,
  mapVisible: false, // 地图是否显示

  editFlag: '',
  resetMessage: false,
  isRotating: false,
  isGettedDistance: false,
  clearFlag: false,

  cargoTabsArr: [],
  portsRotationArr: [],
  portRouteList: [],
  portRouteIds: [],

  marginSeaDay: '',
  marginWorkDay: '',
  marginIdleDay: '',
  rotationTtlSeaDay: 0,
  rotationTtlWorkDay: 0,
  rotationTtlIdleDay: 0,
  ttlVoyDays: 0,
  ttlSeaDays: 0,
  ttlPortIdleDays: 0,
  ttlPortWorkDays: 0,

  shipFixedCost: '',
  shipInfo: {
    ShipID: '',
    ShipName: '',
    SpeedType: '1',
    SpeedBallast: 12,
    SpeedLaden: 12,
    DOBallast: '',
    DOPortIdle: '',
    DOPortWork: '',
    DOSea: '',
    FOBallast: '',
    FOLaden: '',
    FOPortIdle: '',
    FOPortWork: ''
  },

  foPrice: 0,
  doPrice: 0,

  // cost pad
  HirePerDay: '',
  HireCommPercent: '',
  Demurrage: '',
  Dispatch: '',
  ILOHC: '',
  BallastBonus: '',
  OpOther: '',
  CEV: '',

  otherOpExp: '', // 其他费用
  exchangeRate: '',
  ttlRevenue: '', // 航次收入
  opProfit: '', // 航次利润
  ttlExp: '', // 航次费用
  hireDdayLevel: '', // 期租日租金

  addCommRateVal: '',
  brokerageRateVal: ''
}

// getters
const getters = {
  getCargoTabLabel: (state) => (index) => {
    if (state.cargoTabsArr[index].cgoType) {
      '货物 (' + state.cargoTabsArr[index].cgoType + ')'
    }
    return '货物'
  },

  checkCargosRequired (state, getters) {
    for (var i = 0; i < state.cargoTabsArr.length; i++) {
      if (_.trim(state.cargoTabsArr[i].cgoType) === '' ||
        state.cargoTabsArr[i].lPort.portId.length == 0 ||
        state.cargoTabsArr[i].dPort.portId.length == 0) {
        return i
      }
    }
    return -1
  },

  getTtlIncome (state, getters) { // 运费收入
    var total = 0
    state.cargoTabsArr.forEach((ele, index) => {
      if (_.isNumber(ele.Income)) {
        total += ele.Income
      }
    })
    return _.round(total, 2)
  },

  getAddCommRateVal (state, getters) {
    var total = 0
    state.cargoTabsArr.forEach((ele, index) => {
      if (Number(ele.AddComm)) {
        total += ele.AddComm
      }
    })
    return _.round(total, 2)
  },
  getBrokerageRateVal (state, getters) {
    var total = 0
    state.cargoTabsArr.forEach((ele, index) => {
      if (Number(ele.Brokerage)) total += ele.Brokerage
    })
    return _.round(total, 2)
  },
  getFrtTax (state, getters) {
    var total = 0
    state.cargoTabsArr.forEach((ele, index) => {
      if (Number(ele.FrtTax)) total += ele.FrtTax
    })
    return _.round(total, 2)
  },

  getRotationTtlDays (state, getters) {
    var seaDays = 0; var idleDays = 0; var workDays = 0
    state.portsRotationArr.forEach((ele, index) => {
      seaDays += _.toNumber(ele.seaDays)
      idleDays += _.toNumber(ele.idleDays)
      workDays += _.toNumber(ele.workDays)
    })
    return {
      seaDays: _.round(seaDays, 2),
      idleDays: _.round(idleDays, 2),
      workDays: _.round(workDays, 2)
    }
  },
  getTtlSeaDays (state, getters) {
    return _.round((_.toNumber(state.marginSeaDay) || 0) +
      getters.getRotationTtlDays.seaDays, 2)
  },
  getTtlPortIdleDays (state, getters) {
    return (_.toNumber(state.marginIdleDay) || 0) +
      getters.getRotationTtlDays.idleDays
  },
  getTtlPortWorkDays (state, getters) {
    return (_.toNumber(state.marginWorkDay) || 0) +
      getters.getRotationTtlDays.workDays
  },
  getTtlVoyDays (state, getters) {
    return _.round(getters.getTtlSeaDays +
      getters.getTtlPortIdleDays + getters.getTtlPortWorkDays, 2)
  },

  getPortCharge (state, getters) {
    var total = 0
    state.portsRotationArr.forEach((ele, index) => {
      if (_.toNumber(ele.portCharge)) total += _.toNumber(ele.portCharge)
    })
    return _.round(total, 2)
  },
  getPortchargeTaxFee (state, getters) {
    if (Number(state.portchargeTax) && Number(getters.getPortCharge)) {
      return _.round(getters.getPortCharge /
        (1 + _.toNumber(state.portchargeTax) / 100) * _.toNumber(state.portchargeTax) / 100)
    }
    return 0
  },

  getFuelConsumption (state, getters) { // 油耗计算
    var foConsump = 0; var doConsump = 0

    if (state.isGettedDistance) {
      var shipInfo = state.shipInfo

      var rotationSeaDays = 0
      var norSeaLaden = 0
      var norSeaBallast = 0
      var portIdleDays = 0
      var portWorkDays = 0

      var foPortIdleConsump = 0 // 港口（空闲）fo消耗
      var foPortWorkConsump = 0 // 港口（作业）fo消耗
      var doPortIdleConsump = 0 // 港口（空闲）do消耗
      var doPortWorkConsump = 0 // 港口（作业）do消耗

      var foSeaLadenConsump = 0 // 装载 fo消耗
      var foSeaBallastConsump = 0 // 空载 fo消耗
      var doSeaLadenConsump = 0 // 装载 do消耗
      var doSeaBallastConsump = 0 // 空载 do消耗

      state.portsRotationArr.forEach((ele, index) => {
        var norDistance = ele.distance
        rotationSeaDays += ele.seaDays
        if (ele.speed > 0) {
          const nd = _.round(norDistance / ele.speed / 24, 2)
          if (ele.taskType === Constant.TASK_TYPE_DISCHARING) { // 卸货
            norSeaLaden += nd
          } else {
            norSeaBallast += nd
          }
        } // end speed

        portIdleDays += _.toNumber(ele.idleDays) || 0
        portWorkDays += _.toNumber(ele.workDays) || 0
      }) // end forEach

      // 全速经济 默认相同
      foPortIdleConsump = portIdleDays * _.toNumber(shipInfo.FOPortIdle)
      foPortWorkConsump = portWorkDays * _.toNumber(shipInfo.FOPortWork)
      doPortIdleConsump = portIdleDays * _.toNumber(shipInfo.DOPortIdle)
      doPortWorkConsump = portWorkDays * _.toNumber(shipInfo.DOPortWork)

      foSeaLadenConsump = norSeaLaden * _.toNumber(shipInfo.FOLaden)
      foSeaBallastConsump = norSeaBallast * _.toNumber(shipInfo.FOBallast)
      doSeaLadenConsump = norSeaLaden * _.toNumber(shipInfo.DOSea)
      doSeaBallastConsump = norSeaBallast * _.toNumber(shipInfo.DOBallast)

      // margin
      // idle
      foPortIdleConsump += _.toNumber(state.marginIdleDay) * _.toNumber(shipInfo.FOPortIdle)

      // work
      foPortWorkConsump += _.toNumber(state.marginWorkDay) * _.toNumber(shipInfo.FOPortWork)

      // marginSeaDay
      if (rotationSeaDays > 0) {
        foSeaLadenConsump += _.toNumber(shipInfo.FOLaden) * _.toNumber(state.marginSeaDay) *
          (norSeaLaden / rotationSeaDays)
        doSeaLadenConsump += _.toNumber(shipInfo.DOSea) * _.toNumber(state.marginSeaDay) *
          (norSeaLaden / rotationSeaDays)

        foSeaBallastConsump += _.toNumber(shipInfo.FOBallast) * _.toNumber(state.marginSeaDay) *
          (norSeaBallast / rotationSeaDays)
        doSeaBallastConsump += _.toNumber(shipInfo.DOBallast) * _.toNumber(state.marginSeaDay) *
          (norSeaBallast / rotationSeaDays)
      }

      foConsump = foSeaLadenConsump + foSeaBallastConsump +
        foPortIdleConsump + foPortWorkConsump
      doConsump = doSeaLadenConsump + doSeaBallastConsump +
        doPortIdleConsump + doPortWorkConsump
    }

    return {
      foConsump: _.round(foConsump, 2),
      foSeaLadenConsump: _.round(foSeaLadenConsump, 2),
      foSeaBallastConsump: _.round(foSeaBallastConsump, 2),
      foPortIdleConsump: _.round(foPortIdleConsump, 2),
      foPortWorkConsump: _.round(foPortWorkConsump, 2),

      doConsump: _.round(doConsump, 2),
      doSeaLadenConsump: _.round(doSeaLadenConsump, 2),
      doSeaBallastConsump: _.round(doSeaBallastConsump, 2),
      doPortIdleConsump: _.round(doPortIdleConsump, 2),
      doPortWorkConsump: _.round(doPortWorkConsump, 2)
    }
  },

  getFuelCost (state, getters) {
    var foFee, doFee, totalFuelFee
    if (state.isGettedDistance) {
      var fuelConsump = getters.getFuelConsumption
      foFee = (_.toNumber(state.foPrice) || 0) * fuelConsump.foConsump
      doFee = (_.toNumber(state.doPrice) || 0) * fuelConsump.doConsump

      totalFuelFee = foFee + doFee
      return {
        foFee: _.round(foFee, 2),
        doFee: _.round(doFee, 2),
        totalFuelFee: _.round(totalFuelFee, 2)
      }
    } else {
      return {
        foFee: 0,
        doFee: 0,
        totalFuelFee: 0
      }
    }
  },

  getRent (state, getters) { // 租金
    let total = 0
    if (Number(state.HirePerDay) && Number(getters.getTtlVoyDays)) {
      total = _.toNumber(state.HirePerDay) * _.toNumber(getters.getTtlVoyDays)
      return _.round(total, 2)
    } else return 0
  },
  getRentAndCom (state, getters) { // 租金佣金
    let total = 0
    if (Number(state.HireCommPercent)) {
      total = getters.getRent * (_.toNumber(state.HireCommPercent) / 100)
      return _.round(total, 2)
    } else return 0
  },
  // 租金成本
  getRentCost (state, getters) {
    let total = 0
    total = getters.getRent - getters.getRentAndCom
    return _.round(total, 2)
  },

  getTtlRevenue (state, getters) { // 航次收入 = 滞期费 + 运费收入(不含税)
    var total = 0
    if (_.isNumber(getters.getTtlIncome)) {
      total += getters.getTtlIncome
    }
    return _.round(total, 2)
  },

  // 航次成本
  getOpExpense (state, getters) {
    let total = 0
    total += _.toNumber(getters.getFuelCost.totalFuelFee) || 0
    total += _.toNumber(getters.getPortCharge) || 0
    total += _.toNumber(getters.getAddCommRateVal) || 0
    total += _.toNumber(getters.getBrokerageRateVal) || 0
    total += _.toNumber(getters.getFrtTax) || 0

    total += _.toNumber(state.Dispatch) || 0
    total -= _.toNumber(state.Demurrage) || 0
    total += _.toNumber(state.OpOther) || 0
    total += _.toNumber(state.ILOHC) || 0
    total += _.toNumber(state.BallastBonus) || 0
    total += ((_.toNumber(state.CEV) || 0) * 12 * (_.toNumber(getters.getTtlVoyDays) || 0)) / 365
    return _.round(total, 2)
  },

  // 航次费用
  getTtlExpense (state, getters) {
    let total = 0
    total = getters.getOpExpense + getters.getRentCost
    return _.round(total, 2)
  },

  getOpProfit (state, getters) { // 航次净利润 = 航次收入 -（航次费用）-（固定成本）
    return _.round(getters.getTtlRevenue) - _.round(getters.getOpExpense)
  },

  // 日租金水平
  getHirePerDay (state, getters) {
    let total = 0
    if (getters.getTtlVoyDays > 0) {
      total = Number(getters.getOpProfit) / getters.getTtlVoyDays
      return _.round(total, 2)
    } else return 0
  },

  getTtlFixedCost (state, getters) { // 总固定成本
    if (_.isNumber(state.shipFixedCost) && _.isNumber(getters.getTtlVoyDays)) {
      return _.round(state.shipFixedCost * getters.getTtlVoyDays, 2)
    }
    return ''
  },

  getProfit (state, getters) { // 期租收入 = 航次收入 - 航次费用
    if (_.isNumber(getters.getTtlRevenue) && _.isNumber(getters.getTtlExpense)) {
      return _.round(getters.getTtlRevenue) - _.round(getters.getTtlExpense)
    }
    return ''
  },

  getHireDayLevel (state, getters) { // 期租日租金
    if (getters.getTtlVoyDays > 0 && _.isNumber(getters.getOpProfit)) {
      const hireDdayLevel = getters.getProfit / getters.getTtlVoyDays
      return _.round(hireDdayLevel, 2)
    }
    return ''
  }
}

// actions
const actions = {

}

// mutations
const mutations = {
  setResetMessage (state, payload) {
    state.resetMessage = payload
  },
  setEditFlag (state, payload) {
    state.editFlag = payload
  },
  setClearFlag (state, payload) {
    state.clearFlag = payload
  },
  setIsRotating (state, payload) {
    state.isRotating = payload
  },

  setEstiIsGettedDistance (state, payload) {
    state.isGettedDistance = payload
  },

  setCargoTabArr (state, payload) {
    state.cargoTabsArr = _.cloneDeep(payload)
  },
  updateCargoByIndex (state, payload) {
    state.cargoTabsArr.splice(payload.index, 1, _.cloneDeep(payload.form))
  },
  removeCargoTab (state, payload) {
    state.cargoTabsArr.splice(payload, 1)
  },

  updateEstiShipInfo (state, payload) {
    state.shipInfo = _.cloneDeep(payload)
    //console.log("updateEstiShipInfo",state.shipInfo,state.portsRotationArr)
  },

  setMarginSeaDay (state, payload) {
    if (Number(payload)) { state.marginSeaDay = payload - 0 } else {
      state.marginSeaDay = 0
    }
  },
  setMarginIdleDay (state, payload) {
    if (Number(payload)) {
      state.marginIdleDay = payload - 0
    } else {
      state.marginIdleDay = 0
    }
  },
  setMarginWorkDay (state, payload) {
    if (Number(payload)) { state.marginWorkDay = payload - 0 } else {
      state.marginWorkDay = 0
    }
  },
  setFuelPrice (state, payload) {
    state.foPrice = payload.foPrice
    state.doPrice = payload.doPrice
  },

  setEstiGlobalField (state, payload) {
    state[payload.name] = payload.val
  },

  setPortsRotationArr (state, payload) { // 算是一次性提交
    state.portsRotationArr = _.cloneDeep(payload)
    // 获取后时间
    if (state.portsRotationArr && state.portsRotationArr.length > 0) {
      state.voyEndTime = new Date(state.portsRotationArr[state.portsRotationArr.length - 1].departTime)
    }
  },
  updatePortsRotationByIndex (state, payload) {
    state.portsRotationArr.splice(payload.index, 1, _.cloneDeep(payload.rotation))
  },

  setTtlVoyInfo (state, payload) {
    state.ttlVoyDays = payload.ttlVoyDays
    state.ttlSeaDays = payload.ttlSeaDays
    state.ttlPortIdleDays = payload.ttlPortIdleDays
    state.ttlPortWorkDays = payload.ttlPortWorkDays
  },

  setCostInfo (state, payload) {
    state.HirePerDay = payload.HirePerDay
    state.HireCommPercent = payload.HireCommPercent
    state.Demurrage = payload.Demurrage
    state.Dispatch = payload.Dispatch
    state.ILOHC = payload.ILOHC
    state.BallastBonus = payload.BallastBonus
    state.OpOther = payload.OpOther
    state.CEV = payload.CEV
  },

  resetEstimatingEmpty (state, payload = {}) {
    for (const [key, value] of Object.entries(state)) {
      var val = state[key]
      if (_.isBoolean(val)) {
        state[key] = false
      } else if (_.isNumber(val)) {
        state[key] = 0
      } else if (_.isString(val)) {
        state[key] = ''
      } else if (_.isPlainObject(val)) {
        if (key === 'shipInfo') {
          state.shipInfo = _.cloneDeep(EstiTmpl.FUEL_FORM)
        }
      } else if (_.isArray(val)) {
        state[key] = []
      }
    }

    state.cargoTabsArr = [_.cloneDeep(EstiTmpl.CARGO_FORM)]
    for (const [key, value] of Object.entries(payload)) {
      state[key] = value
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
